<template>
    <div class="lvshi_box no-trans" v-loading="loading">
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                选择类型
            </div>
            <div class="input2">
                <el-select v-model="forms.type" placeholder="请选择">
                    <el-option
                    v-for="(item,index) in ls_type"
                    :key="index"
                    :label="item.title"
                    :value="item.type">
                    </el-option>
                </el-select> 
            </div>
        </div>
        <div class="form_flex_box">
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    姓名
                </div>
                <div class="input2">
                    <el-input v-model="forms.name" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    身份证号
                </div>
                <div class="input2">
                    <el-input v-model="forms.identity" placeholder="请输入内容"></el-input>
                </div>
            </div>
        </div>
      
        <div class="form_flex_box">
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    律师执业资格证号码
                </div>
                <div class="input2">
                    <el-input v-model="forms.license_num" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    手机号
                </div>
                <div class="input2">
                    <el-input v-model="forms.mobile" placeholder="请输入内容" disabled></el-input>
                </div>
            </div>
        </div>
        <div class="form_flex_box">
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    电子邮箱
                </div>
                <div class="input2">
                    <el-input v-model="forms.email" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    所在地区 
                </div>
                <div class="input5">
                    <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                </div>
            </div>
        </div>
        
        <!-- <div class="form_flex" v-if="forms.type==1">
            <div class="form_title">
                所在单位（律所）
            </div>
            <div class="input2">
                <el-input v-model="forms.work_company" placeholder="请输入内容"></el-input>
            </div>
        </div> -->
        <div class="form_flex_box" v-if="forms.type==1">
            <div class="form_flex">
                <div class="form_title">
                    所在单位（律所）
                </div>
                <div class="input2">
                    <el-input v-model="forms.work_company" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    律所规模
                </div>
                <div class="input2">
                    <el-input v-model="forms.company_guimo" placeholder="请输入内容"></el-input>
                </div>
            </div>
            
        </div>

        <div class="form_flex_box" v-if="forms.type==1">
         
         <div class="form_flex">
             <div class="form_title">
                 <!-- <span>*</span> -->
                 职务
             </div>
             <div class="input2">
                 <el-input v-model="forms.zhiwu" placeholder="请输入内容"></el-input>
             </div>
         </div>
         <div class="form_flex">
             <div class="form_title">
                 执业年份
             </div>
             <div class="input2">
                 <!-- <el-input v-model="forms.business_year" placeholder="请输入内容"></el-input> -->
                 <!-- <el-date-picker
                    v-model="forms.business_year" 
                    type="date"
                    placeholder="选择年份"
                    value-format="yyyy 年 mm 月 dd 日">
                </el-date-picker> -->
                <el-date-picker
                    v-model="forms.business_year"
                    type="year"
                    placeholder="选择日期"
                    @change="change_business_year"
                    value-format="yyyy">
                </el-date-picker>
                
             </div>
         </div>
     </div>

        <div class="form_flex_box" v-if="forms.type==1">
            <div class="form_flex">
                <div class="form_title">
                    微信
                </div>
                <div class="input2">
                    <el-input v-model="forms.wx" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    联系地址
                </div>
                <div class="input2">
                    <el-input v-model="forms.mobile_address" placeholder="请输入内容"></el-input>
                </div>
            </div>

        </div>

      

        <div class="form_flex_box" v-if="forms.type==1">
            
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    团队描述
                </div>
                <div class="input2">
                    <el-input v-model="forms.team_info" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    最高学历
                </div>
                <div class="input2">
                    <el-input v-model="forms.max_edu" placeholder="请输入内容"></el-input>
                </div>
            </div>
        </div>

        <div class="form_flex_box" v-if="forms.type==1">
           
            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    毕业院校
                </div>
                <div class="input2">
                    <el-input v-model="forms.school" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    所学专业
                </div>
                <div class="input2">
                    <el-input v-model="forms.major" placeholder="请输入内容"></el-input>
                </div>
            </div>
        </div>
        <div class="form_flex_box" v-if="forms.type==1">
           
           <div class="form_flex">
               <div class="form_title">
                   <span>*</span>
                   擅长分类
               </div>
               <div class="input2">
                <!-- <el-cascader placeholder="请选择案由" clearable v-model="cause_ac" :options="cause_list"  :props="cause_props"></el-cascader> -->


                <el-select v-model="cause_ac" multiple collapse-tags placeholder="请选择">
                    <el-option v-for="item in cause_list" :key="item.value" :label="item.title" :value="item.id">
                    </el-option>
                </el-select>


               </div>
           </div>
           
       </div>


















        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                专业擅长
            </div>
            <div class="input3">
                <el-input type="textarea"  placeholder="请输入内容" v-model="forms.serve"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                个人简介
            </div>
            <div class="input3">
                <el-input type="textarea"  placeholder="请输入内容" v-model="forms.info"></el-input>
            </div>
        </div>
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                上传资格证扫描件
            </div>
            <div class="input_img">
                <div class="img_text">请上传资格证内页扫描件，格式为jpg、png</div>
                <div class="img_list">
                    <div class="img_item" v-for="(item,index) in license_images">
                        <!-- <img src="../../assets/img/login/img_up.png" alt="" class="imgs"> -->
                        <img :src="item" alt="" class="imgs">
                        <img src="../../assets/img/login/clear.png" alt="" class="img_clear" @click="handle_clear(index,'license_images')">
                    </div>
                    <img src="../../assets/img/login/img_up.png" alt="" class="img_add" @click="handle_img_add('license_images')">
                </div>
            </div>
        </div> 
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                上传职业装照片
                <br>
               （用于个人简介）
            </div>
            <div class="input_img">
                <div class="img_text">上传职业装照片（用于个人简介），格式为jpg、png</div>
                <div class="img_list">
                    <div class="img_item" v-for="(item,index) in business_img">
                        <!-- <img src="../../assets/img/login/img_up.png" alt="" class="imgs"> -->
                        <img :src="item" alt="" class="imgs">

                        <img src="../../assets/img/login/clear.png" alt="" class="img_clear" @click="handle_clear(index,'business_img')">


                    </div>
                    <img src="../../assets/img/login/img_up.png" alt="" class="img_add" @click="handle_img_add('business_img')" v-if="business_img.length==0">
                </div>
            </div>
        </div> 






       
        <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                期望从网站中获得什么
            </div>
            <div class="input3">
                <el-input type="textarea"  placeholder="请输入内容" v-model="forms.desire"></el-input>
            </div>
        </div>
        <!-- <div class="form_flex">
            <div class="form_title">
                <span>*</span>
                是否要成为区域合伙人
            </div>
            <div class="input4">
                <el-radio v-model="forms.if_join" :label="1">是</el-radio>
                <el-radio v-model="forms.if_join" :label="2">否</el-radio>
            </div>
        </div> -->
        <div class="form_flex">
            <div class="form_title">
            </div>
            <div class="btn_flex">
                <div class="btns1" @click="handle_end">提交</div>
                <div class="btns2" @click="$router.back()">取消</div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import upload from '@/components/upload/upload.vue'

export default {
    components: {
        upload,
    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            loading:false,
            forms:{
                type:1,
                name:'',//姓名
                identity:'',//身份证号
                license_num:'',//律师执业资格证号码
                mobile:'',//手机号
                email:'',//电子邮箱
                province:'',//省
                city:'',//市
                area:'',//区
                work_company:'',//所在单位
                company_guimo:'',//律所规模
                zhiwu:'',//职务
                business_year:'',//执业年份
                wx:'',//微信
                mobile_address:'',//联系地址


                team_info:'',//团队描述
                max_edu:'',//最高学历
                school:'',//毕业院校
                major:'',//所学专业
 
              




                serve:'',//擅长领域
                info:'',//个人简介
                license_images:'',//资格证照片
                business_img:'',//职业装照片
                desire:'',//期望获得什么
                if_join:'0',//是否要成为区域合伙人 1是 2否 0不填
               


            },
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
            ls_type:[
                {
                    title:'执业律师（持律师实习证或律师执业证）',
                    type:1,
                },
                {
                    title:'非执业律师（仅持法律从业资格证）',
                    type:2,
                }
            ],
            license_images:[],//资格证照片
            business_img:[],//职业装照片
            cause_list:[],//案由列表
            cause_ac:[],
            cause_props:{
                label:'title',
                value:'id',
                children:'child',
            },
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_area()
        this.get_user()
        this.get_cause_list()

    },
    methods: {
        //获取分类
        get_cause_list(){
            this.$api("cause", {
                
				// type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('案由',res)
                if (res.code == 1) {
                    this.cause_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_user(){
            this.loading=true
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                    for (const key in this.forms) {
                        this.forms[key]=res.data[key]
                    }
                    this.license_images=res.data.license_images.split(',')
                    this.business_img=res.data.business_img.split(',')
                    this.area_ac=[res.data.province,res.data.city,res.data.area]
                    this.forms.type=res.data.type==2?1:2
                    let list=res.data.causeIds.split(',')
                    list.forEach((e)=>{
                        this.cause_ac.push(Number(e))
                    })
                    this.forms.business_year=res.data.business_year+'' 
                    // this.forms.business_year='' 

                    // console.log('分类',JSON.parse(res.data.causeIds))
                } else {
                    // alertErr(res.msg)
                }
            });
        },
        change_business_year(e){
            console.log('e',e)
        },
        //获取地区列表
        get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
       //地区选择触发
       handleChange(e){
            console.log('选择',e)
        },
        //回到首页
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        //触发上传
        handle_img_add(text){
            let datas={
                form_title:text,
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this[datas.form_title].push(res_data.path)
        },
        //删除图片
        handle_clear(index,text){
            this[text].splice(index,1)
        },
        //提交
        handle_end(){
            if(!this.forms.name){
                alertErr('请输入姓名')
                return
            }
            if(!this.forms.identity){
                alertErr('请输入身份证号')
                return
            }
            if(!this.forms.license_num){
                alertErr('请输入律师执业资格证号码')
                returnuserla
            }
            
            if(!this.forms.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.forms.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.forms.email){
                alertErr('请输入电子邮箱')
                return
            }
            if(this.area_ac.length==0){
                alertErr('请选择所在地区')
                return
            }
            if(this.area_ac.length!=0){
                this.forms.province=this.area_ac[0]
                this.forms.city=this.area_ac[1]
                this.forms.area=this.area_ac[2]
            }
            if(!this.forms.serve){
                alertErr('请输入专业擅长')
                return
            } 
            if(!this.forms.info){
                alertErr('请输入个人简介')
                return
            }
            if(this.license_images.length==0){
                alertErr('请上传资格证扫描件')
                return
            }
            this.forms.license_images=this.license_images.join(',')
            if(this.business_img.length==0){
                alertErr('请上传职业装照片')
                return
            }
            this.forms.business_img=this.business_img.join(',')
            
            if(this.cause_ac.length==0){
                alertErr('请选择擅长分类')
                return
            }
            this.forms.causeIds=this.cause_ac.join(',')


            this.end2()
        },
        end2(){
            this.loading=true
            this.$api("supplement", {
                ...this.forms,
                type:this.forms.type==1?2:3,

			}, "post").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {

                   
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
.lvshi_box{
    width: 100%;
    padding-right:40px ;
    .form_flex_box{
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        .form_flex:nth-child(2n){
            .form_title{
                width: 160px;
            }
        }
    }
    .form_flex{
        display: flex;
        // align-items: center;
        padding-bottom: 24px;

        .form_title{
            width: 200px;
            height: 40px;
            line-height: 40px;
            text-align: right;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-right: 24px;
            flex-shrink: 0;
            span{
                color: #FD4C5C; 
            }
        }
        .input2{
            display: flex;
            align-items: center;
            /deep/.el-select{
                width: 400px;
                height: 40px;
            }
            /deep/.el-input{
                width: 400px;
                height: 40px;
            }
            .input_text1{
                padding-left: 15px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #888888;
 
            }

        }
        .input3{
            width: 100%;
            height: 93px;
            /deep/.el-textarea{
                width: 100%;
                height: 93px;
                .el-textarea__inner{
                    width: 100%;
                    height: 93px;
                    resize:none
                }
            }
        }
        .input4{
            display: flex;
            align-items: center;
        }
        .input5{
            width: 400px;

            display: flex;
            align-items: center;
            justify-content: space-between;
            /deep/.el-select{
                // width: 125px;
            }
            /deep/.el-cascader{
                width: 400px;

            }
        }
        .input_img{
            .img_text{
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #999999;
            }
            .img_list{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding-top: 8px;
                .img_item{
                    position: relative;
                    width: 80px;
                    height: 80px;
                    margin-right: 10px;
                    .imgs{
                        width: 80px;
                        height: 80px;
                    }
                    .img_clear{
                        position: absolute;
                        right: 0;
                        top: 0;
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                    }

                }
                .img_add{
                    width: 80px;
                    height: 80px;
                    cursor: pointer;
                }
            }
        }
        .btn_flex{
            display: flex;
            align-items: center;
            .btns1{
                width: 134px;
                height: 40px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;

            }
            .btns2{
                width: 134px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;

                margin-left: 10px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #377CFD;

            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .lvshi_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-right: 16px;
    }
    .lvshi_box.no-trans .form_flex_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        flex-direction: column;
        align-items: stretch;
    }
    .lvshi_box.no-trans .form_flex_box .form_flex:nth-child(2n) .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        text-align: left;
        line-height: 1.6;
        padding: 0;
    }
    .lvshi_box.no-trans .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .lvshi_box.no-trans .form_flex .form_title {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
        line-height: 1.6;
        font-size: 14px;
        padding-right: 16px;
        text-align: left;
        padding: 0;
    }
    .lvshi_box.no-trans .form_flex .input2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .lvshi_box.no-trans .form_flex .input2 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .lvshi_box.no-trans .form_flex .input2 /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .lvshi_box.no-trans .form_flex .input2 .input_text1 {
        padding-left: 15px;
        font-size: 14px;
    }
    .lvshi_box.no-trans .form_flex .input3 {
        min-height: 0;
        height: auto;
        max-width: 100%;
        min-width: 0;
    }
    .lvshi_box.no-trans .form_flex .input3 /deep/ .el-textarea {
        min-height: 0;
        height: auto;
    }
    .lvshi_box.no-trans .form_flex .input3 /deep/ .el-textarea .el-textarea__inner {
        min-height: 0;
        height: auto;
    }
    .lvshi_box.no-trans .form_flex .input4 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .lvshi_box.no-trans .form_flex .input5 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }
    .lvshi_box.no-trans .form_flex .input5 /deep/ .el-cascader {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_text {
        line-height: 40px;
        font-size: 14px;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 8px;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_list .img_item {
        width: 80px;
        height: 80px;
        margin-right: 10px;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_list .img_item .imgs {
        width: 80px;
        height: 80px;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_list .img_item .img_clear {
        width: 20px;
        height: 20px;
    }
    .lvshi_box.no-trans .form_flex .input_img .img_list .img_add {
        width: 80px;
        height: 80px;
    }
    .lvshi_box.no-trans .form_flex .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lvshi_box.no-trans .form_flex .btn_flex .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .lvshi_box.no-trans .form_flex .btn_flex .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        margin-left: 10px;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
